"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var FilterOption = function FilterOption(_ref) {
  var id = _ref.id,
    isActive = _ref.isActive,
    name = _ref.name,
    _onChange = _ref.onChange,
    option = _ref.option;
  var label = option.label;
  var filterOptionClass = function filterOptionClass() {
    return (0, _classnames["default"])(_defineProperty(_defineProperty({
      'ui-filter-single-option': true,
      isActive: isActive
    }, "level-".concat(option.level), _lodash["default"].has(option, 'hasChildren')), 'has-children', option.hasChildren));
  };
  if (_lodash["default"].get(option, 'hasChildren', false)) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: filterOptionClass()
    }, /*#__PURE__*/_react["default"].createElement("span", null, label));
  }
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    _react["default"].createElement("div", {
      className: filterOptionClass(),
      "aria-label": label,
      tabIndex: 0
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "ui-label-roman",
      htmlFor: "".concat(id)
    }, /*#__PURE__*/_react["default"].createElement("input", {
      checked: isActive === option.value,
      id: "".concat(id),
      name: name,
      onChange: function onChange(e) {
        return _onChange(option, e.target.value);
      },
      type: "radio",
      value: option.value
    }), /*#__PURE__*/_react["default"].createElement("span", {
      id: "".concat(id, "-label")
    }, label)))
  );
};
FilterOption.propTypes = {
  id: _propTypes["default"].string.isRequired,
  isActive: _propTypes["default"].bool.isRequired,
  name: _propTypes["default"].string.isRequired,
  option: _propTypes["default"].object.isRequired,
  onChange: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = FilterOption;